import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FieldRenderComponent from '../FieldRenderComponent';
import fields from './fields';
import { reduxForm } from 'redux-form';
import { updateTitle } from '../SectionTitle/actions';
import HistoryForm from './HistoryForm';
import constants from '../Constants';

const mapStateToProps = (state) => {
    return {
        state: state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateTitle: (titleObj) => dispatch(updateTitle(titleObj))
    }
}

class HistoryContainer extends Component {
    constructor(props){
        super(props);
        this.onNextPage = this.onNextPage.bind(this);
        this.onPrevPage = this.onPrevPage.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.updateTitle({
            title: '<h1>Coverage</h1>',
            subTitle: `<div><span class="estimateMonths">$${this.props.state.userConfirmation.estimate}</span> for 6 months</div>`,
            image: '<i class="fa fa-history" aria-hidden="true"></i>'
        });        
    }
    onNextPage(){
        const {history} = this.props;
        history.push('endquote');
    }

    onPrevPage(){
        const {history} = this.props;
        history.goBack();
    }
    render() {
        console.log(this.props.state.ReviewReducer.policies);
        if (this.props.state.ReviewReducer.reviewData) {
            console.log(this.props.state.ReviewReducer.policies);
            const { policies } = this.props.state.ReviewReducer.reviewData;
            const currentHistory = policies[0];
            const {
                policyStatus,
                carrier,
                coverages,
                policyHolders,
                addresses,
                inceptionDate,
                lastReportedTermEffectiveDate,
                lastReportedTermExpirationDate } = currentHistory;

            return (
                <div>
                    {/*
                    <code>
                        {JSON.stringify(currentHistory)}
                    </code>
                    */}

                    <HistoryForm />
                    <div className="app-form-actions">
                    <button
                        className="btn btn-primary app-align-right"
                        onClick={this.onNextPage}>
                        {'Ready to Review '}
                        <i className={constants.icons.next} />
                    </button>
                    <button
                        className="btn btn-primary app-align-left"
                        onClick={this.onPrevPage}>
                        <i className={constants.icons.prev} />
                        {' Back'}
                    </button>
                    </div>

                </div>
            );
        }
        else {
            return (
                <Redirect to="/" />
            )
        }
    }
}

HistoryContainer = reduxForm({
    form: 'history',
    enableReinitialize: true
})(HistoryContainer);

export default connect(mapStateToProps, mapDispatchToProps)(HistoryContainer);


// WEBPACK FOOTER //
// ./src/History/index.js